import { render, staticRenderFns } from "./InvoiceMaterials.vue?vue&type=template&id=916b3ff4&"
import script from "./InvoiceMaterials.vue?vue&type=script&lang=js&"
export * from "./InvoiceMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports